import React, { useContext, useState } from 'react';
import LanguageContext from './LanguageContext';
import Timeline from './components/Timeline';
import Menu from './components/Menu';
import translations from './utils/translation';

const wineOptions = {
  fr: [
    { value: 'rouge', label: 'Vins rouges' },
    { value: 'blanc_sec', label: 'Vins blancs secs' },
    { value: 'blanc_liquoreux', label: 'Vins blancs liquoreux' },
  ],
  en: [
    { value: 'rouge', label: 'Red wines' },
    { value: 'blanc_sec', label: 'Dry white wines' },
    { value: 'blanc_liquoreux', label: 'Sweet white wines' },
  ],
  zh: [
    { value: 'rouge', label: '红葡萄酒' },
    { value: 'blanc_sec', label: '干白葡萄酒' },
    { value: 'blanc_liquoreux', label: '甜白葡萄酒' },
  ],
};

const WineSelection = ({ wineColor, setWineColor }) => {
  const { language } = useContext(LanguageContext);
  const [selected, setSelected] = useState(null);

  const t = translations.wineSelection;
  const legend = t.legendExplanation?.[language];

  const handleWineSelect = (color) => {
    setWineColor(color);
    setSelected(color);
  };

  return (
    <div className="main-section">
      <Menu />

      <h2 className="wine-title">{t.title[language]}</h2>
      <h3 className="wine-subtitle">{t.subtitle[language]}</h3>

      {/* Paragraphe introductif (inchangé) */}
      <div className="wine-paragraph">
        <p>{t.paragraph[language]}</p>
        <p style={{ textAlign: 'center', fontStyle: 'italic' }}>
          {t.quote[language]}
        </p>
      </div>

      {/* ===================================================================
          SEUL BLOC MODIFIÉ : aligne la section "Le Code des millésimes..."
          sur le paragraphe au-dessus (même largeur + centrage).
          Ajuste maxWidth si tu veux matcher au pixel près la maquette.
         =================================================================== */}
      {legend && (
        <div
          className="legend-block"
          style={{
            maxWidth: '820px',       // largeur de lecture comme le paragraphe
            margin: '0 auto 1.75rem',// centrage + espace sous le bloc
            lineHeight: 1.6,
          }}
        >
          <p>
            <strong>{legend.title}</strong>
          </p>

          <ul style={{ paddingLeft: '1.1em', margin: '0.5rem 0 1rem' }}>
            {legend.legend.map(({ label, text }, index) => (
              <li key={index}>
                <strong>{label}</strong> {text}
              </li>
            ))}
          </ul>

          <p style={{ marginTop: '0.75rem' }}>{legend.explanationIntro}</p>

          <ul style={{ paddingLeft: '1.1em', marginTop: '0.5rem' }}>
            {legend.explanationBullets.map((line, index) => (
              <li key={index}>{line}</li>
            ))}
          </ul>
        </div>
      )}
      {/* =================================================================== */}

      <h4 className="wine-select-invite">{t.invite[language]}</h4>

      <div className="homepage-buttons">
        {wineOptions[language].map(({ value, label }) => (
          <button
            key={value}
            onClick={() => handleWineSelect(value)}
            className="homepage-button"
          >
            {label}
          </button>
        ))}
      </div>

      <h4 className="wine-select-invite2">{t.invite2[language]}</h4>

      {selected && (
        <h2
          className="wine-subtitle"
          style={{
            marginTop: '2rem',
            marginBottom: '1rem',
            textTransform: 'uppercase',
          }}
        >
          {t.selectedWineType?.[language]?.[selected]}
        </h2>
      )}

      {selected && <Timeline language={language} wineColor={selected} />}
    </div>
  );
};

export default WineSelection;
